import { Tenant } from '~/types';
import { TenantsRefs, TenantsUrls } from '~/utils/tenantsConfig';

const getCanonicalUrl = (contentUrl: string, tenants?: (Tenant | null)[] | null) => {
  const tenantNames = tenants?.map((tenant) => tenant?.name);
  let tenantUrl = TenantsUrls.Fu;

  if (tenantNames?.includes(TenantsRefs.Ssku)) {
    tenantUrl = TenantsUrls.Ssku;
  }

  if (tenantNames?.includes(TenantsRefs.Su)) {
    tenantUrl = TenantsUrls.Su;
  }

  return `${tenantUrl}${contentUrl}`;
};

export default getCanonicalUrl;
